// extracted by mini-css-extract-plugin
module.exports = {"container":"e_wx","question":"e_xx","button":"e_yx","buttonNegative":"e_zx","buttonPositive":"e_Ax","icon":"e_Bx","iconNegative":"e_Cx","iconPositive":"e_Dx"};